// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  provider: __t.string(),
  modelId: __t.string(),
  displayName: __t.string(),
  contextWindow: __t.u32(),
  priceInputMicrosPerMtok: __t.i64(),
  priceOutputMicrosPerMtok: __t.i64(),
  capabilityFlagsJson: __t.string(),
};
